module.exports = __webpack_public_path__ + "img/2.d8069817.jpg";